import React, { useState } from "react";

import { Box, Typography, makeStyles } from "@material-ui/core";
import { Brand } from "@hubcapp/types";
import { FranchiseAgreementAcceptance } from "@hubcapp/graphql/types/gateway";
import FranAcceptanceDocumentsPage from "./FranAcceptanceDocumentsPage";
import FranchiseDetailsComponent from "./FranchiseDetailsComponent/index";
import PaymentDetailsComponent from "./PaymentDetailsComponent";
import PersonalDetailsComponent from "./PersonalDetailsComponent";
import TitleSection from "@hubcapp/views/AcceptancePageComponent/UI/TitleSection";
import clsx from "clsx";

type Props = {
  data: FranchiseAgreementAcceptance | undefined;
  brand?: string;
  agreementKey: string;
  ddiUrl: string;
  refetch: () => void;
};

const useStyles = makeStyles(theme => ({
  welcomeTitle: {
    fontWeight: 700,
    "&.bsm": {
      fontWeight: 500,
    },
    fontSize: "28px",
    lineHeight: "110%",
  },
  welcomeText: {
    fontWeight: 400,
    "&.bsm": {
      fontWeight: 300,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "18px",
      lineHeight: "27px",
    },
  },
}));

const DetailsComponent: React.FC<Props> = ({
  data,
  agreementKey,
  ddiUrl,
  refetch,
}) => {
  const classes = useStyles();
  const [actualStep, setActualStep] = useState(0);
  const goToStep = (step: number) => {
    window?.scrollTo({ top: 0, behavior: "auto" });
    setActualStep(step);
  };
  const page =
    actualStep === 0 ? (
      <>
        <TitleSection title="Your details" brand={data?.brand} />
        <PersonalDetailsComponent
          data={data}
          refetch={refetch}
          brand={data?.brand ?? "AADS"}
        />
        <TitleSection title="Your franchise" brand={data?.brand} />
        <FranchiseDetailsComponent data={data} />
        <TitleSection title="Your payments" brand={data?.brand} />
        <PaymentDetailsComponent
          ddiUrl={ddiUrl}
          personKey={data?.personKey || ""}
          brand={data?.brand || ""}
          setActualStep={goToStep}
        />
      </>
    ) : (
      <FranAcceptanceDocumentsPage
        agreementKey={agreementKey}
        documents={data?.documents || undefined}
        brand={data?.brand || ""}
      />
    );

  return (
    <Box>
      {actualStep === 0 && (
        <Box marginTop={2}>
          <Typography
            variant="h1"
            component="h1"
            className={clsx(classes.welcomeTitle, {
              bsm: data?.brand === Brand.Bsm,
            })}
          >
            Welcome {data?.firstName},
          </Typography>
          <Box marginTop={2} marginBottom={5}>
            <Typography
              className={clsx(classes.welcomeText, {
                bsm: data?.brand === Brand.Bsm,
              })}
            >
              Congratulations on your new{" "}
              {data?.brand === Brand.Bsm ? "BSM" : "AA"} Franchise. Before you
              continue, please read and confirm all necessary details below.
            </Typography>
          </Box>
        </Box>
      )}
      {page}
    </Box>
  );
};

export default DetailsComponent;
